// extracted by mini-css-extract-plugin
export default {"tableWrapper":"UserTable_tableWrapper__y04RU","table":"UserTable_table__QRkHQ"};